import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { formatDate, formatTime } from './utils/appointmentUtils';

const FailedAppointmentEventValue = ({ event }) => {
  const { t } = useLanguage();

  const value = event.value || {};
  const metaData = event.meta_data || {};

  // Extract raw error information
  const rawErrorMessage = value.debug_raw_response?.data ||
    value.debug_raw_response?.error ||
    metaData.raw_response?.data ||
    metaData.raw_response?.error;

  const hkshResultCode = value.debug_error_details?.hksh_result_code ||
    metaData.error_details?.hksh_result_code;

  const errorCategory = value.debug_error_details?.error_category ||
    metaData.error_details?.error_category;

  return (
    <div className="space-y-2 text-sm">
      <div className="font-medium text-red-600">
        ❌ {t('failedAppointment.title')} - {value.customer_name || t('failedAppointment.notAvailable')}
      </div>

      {/* 錯誤訊息 */}
      <div className="text-red-500">
        🚨 {t('failedAppointment.error')}: {value.error_message || t('failedAppointment.unknownError')}
      </div>

      {/* 原始錯誤資訊 */}
      {rawErrorMessage && (
        <div className="bg-red-50 p-2 rounded border-l-4 border-red-300">
          <div className="text-xs text-red-700 font-medium mb-1">{t('failedAppointment.rawErrorInfo')}:</div>
          <div className="text-xs text-red-600 font-mono break-all">
            {typeof rawErrorMessage === 'string' ? rawErrorMessage : JSON.stringify(rawErrorMessage, null, 2)}
          </div>
        </div>
      )}

      {/* 技術詳情 */}
      {(hkshResultCode || errorCategory) && (
        <div className="bg-gray-50 p-2 rounded text-xs">
          {hkshResultCode && (
            <div>🔢 {t('failedAppointment.errorCode')}: {hkshResultCode}</div>
          )}
          {errorCategory && (
            <div>📂 {t('failedAppointment.errorCategory')}: {errorCategory}</div>
          )}
        </div>
      )}

      {/* 預約詳情 */}
      {/* {value.doctor_name && (
        <div>👨‍⚕️ 醫生: {value.doctor_name}</div>
      )}
      {value.appointment_date && (
        <div>📅 日期: {formatDate(value.appointment_date)}</div>
      )}
      {value.appointment_start_time && (
        <div>🕐 時間: {formatTime(value.appointment_start_time)}</div>
      )}
      {value.location && (
        <div>📍 地點: {value.location}</div>
      )} */}

      {/* 系統資訊 - 所有相關的 IDs */}
      {(value?.confirmed_event_id || metaData?.confirmed_event_id || value.confirmed_info_event_id || value.confirmed_offer_event_id) && (
        <div className="space-y-1">
          <div className="text-xs text-gray-500">{t('failedAppointment.systemInfo')}:</div>
          {(value?.confirmed_event_id || metaData?.confirmed_event_id) && (
            <div className="text-xs text-blue-600 font-medium">
              🆔 {t('failedAppointment.confirmedEventId')}: {value?.confirmed_event_id || metaData?.confirmed_event_id}
            </div>
          )}
          {value.confirmed_info_event_id && (
            <div className="text-xs text-gray-500">📋 {t('failedAppointment.appointmentInfoId')}: {value.confirmed_info_event_id}</div>
          )}
          {value.confirmed_offer_event_id && (
            <div className="text-xs text-gray-500">🗓️ {t('failedAppointment.appointmentOfferId')}: {value.confirmed_offer_event_id}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default FailedAppointmentEventValue;
